/**
 * These constants are all exported from the discovery-api package. Internal constants are stored in the constants file
 * under the ./discovery-api directory.
 */
export const PAGE_TYPE_CATEGORY = 'category';
export const PAGE_TYPE_CART = 'cart';
export const PAGE_TYPE_CART_PURCHASE = 'purchase';
export const PAGE_TYPE_CART_MULTIPLE_PURCHASE = 'multiplePurchase';
export const PAGE_TYPE_CART_PURCHASE_CONFIRMATION = 'purchaseConfirmation';
export const PAGE_TYPE_CART_SUBSCRIBE = 'subscribe';
export const PAGE_TYPE_CART_SUCCESS = 'cartSuccess';
export const PAGE_TYPE_CART_SUCCESS_MODAL = 'cartSuccessModal';
export const PAGE_TYPE_CART_SUCCESS_MODAL_MOBILE = 'cartSuccessModalMobile';
export const PAGE_TYPE_COLLECTION = 'collection_page';
export const PAGE_TYPE_COURSE_LANDING_PAGE_BUNDLE = 'clp-bundle';
export const PAGE_TYPE_COURSE_LANDING_PAGE_COURSE = 'landingPageCourse';
export const PAGE_TYPE_ORG_COURSE_LANDING_PAGE = 'org-course-landing-page';
export const PAGE_TYPE_COURSE_LANDING_PAGE_DISABLED_COURSE_LABEL = 'disabled_course_label';
export const PAGE_TYPE_SEQUENCE_LANDING_PAGE = 'series-landing-page';
export const PAGE_TYPE_COURSE_LANDING_PAGE_DISABLED_COURSE_CATEGORY = 'disabled_course_category';
export const PAGE_TYPE_COURSE_LANDING_PAGE_FREE_COURSE = 'landingPageFreeCourse';
export const PAGE_TYPE_FEATURED_TOPICS = 'featured_topics_page';
export const PAGE_TYPE_FREE_TOPIC = 'free_topic';
export const PAGE_TYPE_LOGGED_IN_HOMEPAGE = 'logged_in_homepage';
export const PAGE_TYPE_LOGGED_OUT_HOMEPAGE = 'logged_out_homepage';
export const PAGE_TYPE_PERSONALIZED_LOGGED_OUT_HOMEPAGE = 'personalized_home';
export const PAGE_TYPE_LOGOUT_PAGE = 'logout_page';
export const PAGE_TYPE_OCCUPATION_LANDING_PAGE = 'occupation_landing_page';
export const PAGE_TYPE_OCCUPATION_RESULT_PAGE = 'occupation_result_page';
export const PAGE_TYPE_ORG_CATEGORY = 'org_category';
export const PAGE_TYPE_ORG_LOGGED_IN_HOMEPAGE = 'org_logged_in_homepage';
export const PAGE_TYPE_ORG_LOGGED_IN_HOMEPAGE_FIXED_UNITS = 'org_logged_in_homepage_fixed_units';
export const PAGE_TYPE_ORG_SUBCATEGORY = 'org_subcategory';
export const PAGE_TYPE_SUBS_CATEGORY = 'subs_category';
export const PAGE_TYPE_SUBS_SUBCATEGORY = 'subs_subcategory';
export const PAGE_TYPE_SUBCATEGORY = 'subcategory';
export const PAGE_TYPE_SUBS_LOGGED_IN_HOMEPAGE = 'subs_logged_in_homepage';
export const PAGE_TYPE_SUBS_LOGGED_IN_HOMEPAGE_FIXED_UNITS = 'subs_logged_in_homepage_fixed_units';
export const PAGE_TYPE_SUBS_TOPIC = 'subs_topic';
export const PAGE_TYPE_SUBS_TOPIC_DYNAMIC = 'subs_topic_dynamic';
export const PAGE_TYPE_TOPIC = 'topic';
export const PAGE_TYPE_TOPIC_DYNAMIC = 'topic_dynamic';
export const PAGE_TYPE_TOPIC_STATIC = 'topic_static';
export const PAGE_TYPE_TOPIC_BUNDLE = 'topic-bundle';
export const PAGE_TYPE_TOPIC_CLP = 'topic-clp';
export const PAGE_TYPE_TOPIC_CONTEXTUAL_HEADER = 'topic-contextual-header';
export const PAGE_TYPE_ORG_TOPIC = 'org_topic';
export const PAGE_TYPE_ORG_TOPIC_DYNAMIC = 'org_topic_dynamic';
export const PAGE_TYPE_ORG_MY_COURSES_PAGE = 'org_my_courses_page';
export const PAGE_TYPE_ONBOARDING = 'onboarding';
export const PAGE_TYPE_LLP = 'llp';
export const PAGE_TYPE_GOV_LOGGED_IN_HOMEPAGE = 'gov_logged_in_homepage';
export const PAGE_TYPE_LEARNING_PATH = 'learning_path_page';
export const PAGE_TYPE_SUBS_LANDING_PAGE = 'subs_landing_page';
export const PAGE_TYPE_COURSE_RETIREMENT = 'course_retirement_page';
export const PAGE_TYPE_LECTURE_QUICK_VIEW = 'lecture_quick_view';
export const PAGE_TYPE_VERNACULAR_LOHP = 'vernacular_lohp';
export const pageTypes = [PAGE_TYPE_CATEGORY, PAGE_TYPE_CART, PAGE_TYPE_CART_PURCHASE, PAGE_TYPE_CART_PURCHASE_CONFIRMATION, PAGE_TYPE_CART_SUBSCRIBE, PAGE_TYPE_CART_SUCCESS, PAGE_TYPE_CART_SUCCESS_MODAL, PAGE_TYPE_COLLECTION, PAGE_TYPE_COURSE_LANDING_PAGE_COURSE, PAGE_TYPE_ORG_COURSE_LANDING_PAGE, PAGE_TYPE_COURSE_LANDING_PAGE_DISABLED_COURSE_LABEL, PAGE_TYPE_COURSE_LANDING_PAGE_DISABLED_COURSE_CATEGORY, PAGE_TYPE_COURSE_LANDING_PAGE_FREE_COURSE, PAGE_TYPE_FEATURED_TOPICS, PAGE_TYPE_FREE_TOPIC, PAGE_TYPE_LOGGED_IN_HOMEPAGE, PAGE_TYPE_LOGGED_OUT_HOMEPAGE, PAGE_TYPE_PERSONALIZED_LOGGED_OUT_HOMEPAGE, PAGE_TYPE_LOGOUT_PAGE, PAGE_TYPE_OCCUPATION_LANDING_PAGE, PAGE_TYPE_OCCUPATION_RESULT_PAGE, PAGE_TYPE_ORG_CATEGORY, PAGE_TYPE_ORG_LOGGED_IN_HOMEPAGE, PAGE_TYPE_ORG_LOGGED_IN_HOMEPAGE_FIXED_UNITS, PAGE_TYPE_ORG_SUBCATEGORY, PAGE_TYPE_SUBCATEGORY, PAGE_TYPE_TOPIC, PAGE_TYPE_TOPIC_DYNAMIC, PAGE_TYPE_TOPIC_STATIC, PAGE_TYPE_TOPIC_CLP, PAGE_TYPE_TOPIC_CONTEXTUAL_HEADER, PAGE_TYPE_ORG_TOPIC, PAGE_TYPE_ORG_TOPIC_DYNAMIC, PAGE_TYPE_ONBOARDING, PAGE_TYPE_LLP, PAGE_TYPE_LEARNING_PATH, PAGE_TYPE_SUBS_CATEGORY, PAGE_TYPE_SUBS_SUBCATEGORY, PAGE_TYPE_SUBS_TOPIC, PAGE_TYPE_SUBS_TOPIC_DYNAMIC, PAGE_TYPE_SUBS_LOGGED_IN_HOMEPAGE, PAGE_TYPE_SUBS_LOGGED_IN_HOMEPAGE_FIXED_UNITS, PAGE_TYPE_SUBS_LANDING_PAGE, PAGE_TYPE_LECTURE_QUICK_VIEW, PAGE_TYPE_VERNACULAR_LOHP];

// This is using for the identifying the type of the related source of the seen discovery item.
export const RelatedSourceTypeOptions = {
  COURSE: 'course',
  LAB: 'lab',
  LECTURE: 'lecture',
  ADAPTIVE_ASSESSMENT: 'adaptive_assessment',
  LEARNING_PATH: 'learning_path',
  CATEGORY: 'category',
  SUBCATEGORY: 'subcategory',
  TOPIC: 'topic'
};

/**
 * Mapping from a given page type to the params that should be sent to the discovery API for that page
 */
export const PAGE_TYPE_TO_PARAMS = {
  [PAGE_TYPE_LLP]: {
    context: 'landing-page',
    source_page: 'lecture_landing_page'
  },
  [PAGE_TYPE_COURSE_LANDING_PAGE_BUNDLE]: {
    context: 'clp-bundle',
    source_page: 'course_landing_page',
    funnel_context: 'landing-page'
  },
  [PAGE_TYPE_CART]: {
    context: 'cart',
    source_page: 'cart_page'
  },
  [PAGE_TYPE_CART_PURCHASE]: {
    context: 'success',
    source_page: 'success_page'
  },
  [PAGE_TYPE_CART_MULTIPLE_PURCHASE]: {
    context: 'success',
    source_page: 'success_page'
  },
  [PAGE_TYPE_CART_PURCHASE_CONFIRMATION]: {
    context: 'success',
    source_page: 'success_page'
  },
  [PAGE_TYPE_CART_SUBSCRIBE]: {
    context: 'success',
    source_page: 'success_page'
  },
  [PAGE_TYPE_CART_SUCCESS]: {
    context: 'mw_add_to_cart',
    source_page: 'course_landing_page'
  },
  [PAGE_TYPE_CART_SUCCESS_MODAL]: {
    context: 'add_to_cart',
    source_page: 'course_landing_page'
  },
  [PAGE_TYPE_CART_SUCCESS_MODAL_MOBILE]: {
    context: 'mw_add_to_cart',
    source_page: 'course_landing_page'
  },
  [PAGE_TYPE_CATEGORY]: {
    context: 'category',
    source_page: 'category_page',
    fl: 'cat',
    sos: 'pc'
  },
  [PAGE_TYPE_COURSE_LANDING_PAGE_COURSE]: {
    context: 'landing-page',
    source_page: 'course_landing_page'
  },
  [PAGE_TYPE_ORG_COURSE_LANDING_PAGE]: {
    context: 'org-landing-page',
    source_page: 'course_landing_page'
  },
  [PAGE_TYPE_COURSE_LANDING_PAGE_DISABLED_COURSE_LABEL]: {
    context: 'disabled_course_label',
    source_page: 'course_landing_page'
  },
  [PAGE_TYPE_COURSE_LANDING_PAGE_DISABLED_COURSE_CATEGORY]: {
    context: 'disabled_course_cat',
    source_page: 'course_landing_page'
  },
  [PAGE_TYPE_COURSE_LANDING_PAGE_FREE_COURSE]: {
    context: 'clp-free',
    source_page: 'course_landing_page'
  },
  [PAGE_TYPE_ORG_CATEGORY]: {
    context: 'org_category',
    source_page: 'org_category_page',
    fl: 'cat',
    sos: 'pc'
  },
  [PAGE_TYPE_SUBCATEGORY]: {
    context: 'subcategory',
    source_page: 'subcategory_page',
    fl: 'scat',
    sos: 'ps'
  },
  [PAGE_TYPE_ORG_SUBCATEGORY]: {
    context: 'org_subcategory',
    source_page: 'org_subcategory_page',
    fl: 'scat',
    sos: 'ps'
  },
  [PAGE_TYPE_LOGGED_IN_HOMEPAGE]: {
    context: 'featured',
    source_page: 'logged_in_homepage'
  },
  [PAGE_TYPE_SUBS_CATEGORY]: {
    context: 'subs_category',
    source_page: 'category_page',
    fl: 'cat',
    sos: 'pc'
  },
  [PAGE_TYPE_SUBS_LOGGED_IN_HOMEPAGE]: {
    context: 'subs_featured',
    source_page: 'logged_in_homepage'
  },
  [PAGE_TYPE_SUBS_LOGGED_IN_HOMEPAGE_FIXED_UNITS]: {
    context: 'subs_featured_fixed_units',
    source_page: 'logged_in_homepage'
  },
  [PAGE_TYPE_SUBS_SUBCATEGORY]: {
    context: 'subs_subcategory',
    source_page: 'subcategory_page',
    fl: 'scat',
    sos: 'ps'
  },
  [PAGE_TYPE_LOGGED_OUT_HOMEPAGE]: {
    context: 'home',
    source_page: 'logged_out_homepage'
  },
  [PAGE_TYPE_LOGOUT_PAGE]: {
    context: 'logout',
    source_page: 'logout_page'
  },
  [PAGE_TYPE_ORG_LOGGED_IN_HOMEPAGE]: {
    context: 'org_featured',
    source_page: 'org_logged_in_homepage'
  },
  [PAGE_TYPE_ORG_LOGGED_IN_HOMEPAGE_FIXED_UNITS]: {
    context: 'org_featured_fixed_units',
    source_page: 'org_logged_in_homepage'
  },
  [PAGE_TYPE_GOV_LOGGED_IN_HOMEPAGE]: {
    context: 'gov_featured',
    source_page: 'org_logged_in_homepage'
  },
  [PAGE_TYPE_TOPIC]: {
    context: 'topic',
    source_page: 'topic_page',
    fl: 'lbl',
    sos: 'pl'
  },
  [PAGE_TYPE_TOPIC_DYNAMIC]: {
    context: 'topic_dynamic',
    source_page: 'topic_page',
    fl: 'lbl',
    sos: 'pl'
  },
  [PAGE_TYPE_TOPIC_STATIC]: {
    context: 'topic_static',
    source_page: 'topic_page',
    fl: 'lbl',
    sos: 'pl'
  },
  [PAGE_TYPE_TOPIC_CLP]: {
    context: 'landing-page-with-topic',
    source_page: 'course_landing_page',
    fl: 'lbl',
    sos: 'pl'
  },
  [PAGE_TYPE_TOPIC_CONTEXTUAL_HEADER]: {
    context: 'topic-contextual-header',
    source_page: 'topic_page'
  },
  [PAGE_TYPE_FREE_TOPIC]: {
    context: 'topic',
    source_page: 'free_topic_page',
    fl: 'lbl',
    sos: 'pl'
  },
  [PAGE_TYPE_ORG_TOPIC]: {
    context: 'org_topic',
    source_page: 'org_topic_page',
    fl: 'lbl',
    sos: 'pl'
  },
  [PAGE_TYPE_ORG_TOPIC_DYNAMIC]: {
    context: 'org_topic_dynamic',
    source_page: 'org_topic_page',
    fl: 'lbl',
    sos: 'pl'
  },
  [PAGE_TYPE_SUBS_TOPIC]: {
    context: 'subs_topic',
    source_page: 'topic_page',
    fl: 'lbl',
    sos: 'pl'
  },
  [PAGE_TYPE_SUBS_TOPIC_DYNAMIC]: {
    context: 'subs_topic_dynamic',
    source_page: 'topic_page',
    fl: 'lbl',
    sos: 'pl'
  },
  [PAGE_TYPE_FEATURED_TOPICS]: {
    source_page: 'featured_topics_page'
  },
  [PAGE_TYPE_TOPIC_BUNDLE]: {
    context: PAGE_TYPE_TOPIC_BUNDLE,
    source_page: 'topic_page',
    funnel_context: 'topic'
  },
  [PAGE_TYPE_PERSONALIZED_LOGGED_OUT_HOMEPAGE]: {
    context: PAGE_TYPE_PERSONALIZED_LOGGED_OUT_HOMEPAGE,
    source_page: PAGE_TYPE_LOGGED_OUT_HOMEPAGE
  },
  // In the case of collections, context is passed in via options
  [PAGE_TYPE_COLLECTION]: {
    context: '',
    source_page: PAGE_TYPE_COLLECTION,
    sos: 'pcoll',
    fl: 'coll'
  },
  [PAGE_TYPE_LEARNING_PATH]: {
    context: 'learning_path',
    source_page: 'learning_path_page',
    fl: 'lbl',
    sos: 'pl'
  },
  [PAGE_TYPE_SEQUENCE_LANDING_PAGE]: {
    context: 'series-landing-page',
    source_page: 'series_landing_page'
  },
  [PAGE_TYPE_OCCUPATION_LANDING_PAGE]: {
    context: 'occ_landing_page',
    source_page: PAGE_TYPE_OCCUPATION_LANDING_PAGE
  },
  [PAGE_TYPE_OCCUPATION_RESULT_PAGE]: {
    context: 'occupation_result',
    source_page: 'occupation_result_page'
  },
  [PAGE_TYPE_SUBS_LANDING_PAGE]: {
    context: 'subs_landing_page',
    source_page: 'subs_landing_page'
  },
  [PAGE_TYPE_COURSE_RETIREMENT]: {
    context: 'course_retirement',
    source_page: 'course_retirement_page',
    fl: 'lbl',
    sos: 'pl'
  },
  [PAGE_TYPE_LECTURE_QUICK_VIEW]: {
    context: 'mls_next_lecture_reco',
    source_page: 'search_page'
  },
  [PAGE_TYPE_VERNACULAR_LOHP]: {
    context: 'vernacular_lang',
    source_page: 'logged_out_homepage'
  }
};
export const OBJECT_ID_PARAMS = {
  [PAGE_TYPE_CATEGORY]: 'category_id',
  [PAGE_TYPE_COLLECTION]: 'collection_id',
  [PAGE_TYPE_CART_SUCCESS_MODAL]: 'course_id',
  [PAGE_TYPE_COURSE_LANDING_PAGE_COURSE]: 'course_id',
  [PAGE_TYPE_ORG_COURSE_LANDING_PAGE]: 'course_id',
  [PAGE_TYPE_COURSE_LANDING_PAGE_BUNDLE]: 'course_id',
  [PAGE_TYPE_COURSE_LANDING_PAGE_DISABLED_COURSE_LABEL]: 'course_id',
  [PAGE_TYPE_COURSE_LANDING_PAGE_DISABLED_COURSE_CATEGORY]: 'course_id',
  [PAGE_TYPE_COURSE_LANDING_PAGE_FREE_COURSE]: 'course_id',
  [PAGE_TYPE_ORG_CATEGORY]: 'category_id',
  [PAGE_TYPE_SUBS_CATEGORY]: 'category_id',
  [PAGE_TYPE_SUBCATEGORY]: 'subcategory_id',
  [PAGE_TYPE_SUBS_SUBCATEGORY]: 'subcategory_id',
  [PAGE_TYPE_ORG_SUBCATEGORY]: 'subcategory_id',
  [PAGE_TYPE_TOPIC]: 'label_id',
  [PAGE_TYPE_TOPIC_DYNAMIC]: 'label_id',
  [PAGE_TYPE_TOPIC_STATIC]: 'label_id',
  [PAGE_TYPE_SUBS_TOPIC]: 'label_id',
  [PAGE_TYPE_SUBS_TOPIC_DYNAMIC]: 'label_id',
  [PAGE_TYPE_FREE_TOPIC]: 'label_id',
  [PAGE_TYPE_TOPIC_BUNDLE]: 'label_id',
  [PAGE_TYPE_TOPIC_CLP]: 'course_id',
  [PAGE_TYPE_TOPIC_CONTEXTUAL_HEADER]: 'label_id',
  [PAGE_TYPE_ORG_TOPIC]: 'label_id',
  [PAGE_TYPE_ORG_TOPIC_DYNAMIC]: 'label_id',
  [PAGE_TYPE_LLP]: 'course_id',
  [PAGE_TYPE_LECTURE_QUICK_VIEW]: 'lecture_id'
};
//# sourceMappingURL=constants.js.map